import { render, staticRenderFns } from "./Ourpartners.vue?vue&type=template&id=30cba50c"
import script from "./Ourpartners.vue?vue&type=script&lang=js"
export * from "./Ourpartners.vue?vue&type=script&lang=js"
import style0 from "./Ourpartners.vue?vue&type=style&index=0&id=30cba50c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports